export enum MagicLinkDeliveryType {
    Email = 0,
    Sms = 1,
}
